import * as z from "zod";

import {
  TABLE_ACCESSOR_BRAND_NAME,
  TABLE_ACCESSOR_CREATED_AT,
  TABLE_ACCESSOR_ID,
  TABLE_ACCESSOR_IS_RESHIP,
  TABLE_ACCESSOR_RECIPIENT_NAME,
  TABLE_ACCESSOR_SHIPPING_STATUS,
} from "~/components/common/orders/order-list";
import {
  OrderTagClaim,
  OrderTagClaimReason,
  OrderTagFulfillment,
  OrderTagRefund,
  OrderTagReship,
  OrderTagReturn,
  OrderTagShipment,
  OrderTagStatus,
} from "~/graphql/graphql.gen";

export const CREATED_AT_ASC = "created-at-asc";
export const CREATED_AT_DESC = "created-at-desc";

export const DISPLAYED_PROPERTIES_BRAND_NAME = TABLE_ACCESSOR_BRAND_NAME;
export const DISPLAYED_PROPERTIES_CREATED_AT = TABLE_ACCESSOR_CREATED_AT;
export const DISPLAYED_PROPERTIES_ID = TABLE_ACCESSOR_ID;
export const DISPLAYED_PROPERTIES_IS_RESHIP = TABLE_ACCESSOR_IS_RESHIP;
export const DISPLAYED_PROPERTIES_RECIPIENT_NAME =
  TABLE_ACCESSOR_RECIPIENT_NAME;
export const DISPLAYED_PROPERTIES_SHIPPING_STATUS =
  TABLE_ACCESSOR_SHIPPING_STATUS;

const sortOrdersQueryParamValues = [CREATED_AT_ASC, CREATED_AT_DESC] as const;

export const DEFAULT_SORT = CREATED_AT_DESC;

export const DEFAULT_DISPLAYED_PROPERTIES = {
  brandName: true,
  createdAt: true,
  id: true,
  isReship: true,
  recipientName: true,
  shippingStatus: true,
};

export type DisplayedPropertiesKeys = keyof typeof DEFAULT_DISPLAYED_PROPERTIES;

export const searchOrdersQueryParamsSchema = z.object({
  brandId: z.string().array().optional(),
  claimReason: z.enum(OrderTagClaimReason).array().optional(),
  claimStatus: z.enum(OrderTagClaim).array().optional(),
  createdAt: z
    .object({
      from: z.string().optional(),
      to: z.string().optional(),
    })
    .optional(),
  fulfillmentStatus: z.enum(OrderTagFulfillment).array().optional(),
  itemReference: z.string().array().optional(),
  orderId: z.string().array().optional(),
  refundStatus: z.enum(OrderTagRefund).array().optional(),
  reshipStatus: z.enum(OrderTagReship).array().optional(),
  returnStatus: z.enum(OrderTagReturn).array().optional(),
  saleId: z.string().array().optional(),
  shippingStatus: z.enum(OrderTagShipment).array().optional(),
  status: z.enum(OrderTagStatus).array().optional(),
  sort: z.enum(sortOrdersQueryParamValues).catch(DEFAULT_SORT),
  displayedProperties: z
    .object({
      brandName: z.boolean(),
      createdAt: z.boolean(),
      id: z.boolean(),
      isReship: z.boolean(),
      recipientName: z.boolean(),
      shippingStatus: z.boolean(),
    })
    .catch(DEFAULT_DISPLAYED_PROPERTIES),
});

export type SearchOrderQueryParams = z.infer<
  typeof searchOrdersQueryParamsSchema
>;
